<template>
  <v-card>
    <v-toolbar dark class="primary">
      <v-btn icon @click.native="$emit('close')" dark>
        <v-icon>fa-times</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12" lg="6" md="6" sm="12">
            <v-autocomplete
                v-model="wybrany_klient"
                :loading="isLoadingClients"
                :items="clientsList"
                :search-input.sync="clientKeyword"
                cache-items
                flat
                no-data-text="Nieznaleziono"
                hide-details
                return-object
                item-text="full_text"
                item-value="id"
                label="Wyszukaj pacjenta Imię/Nazwisko/PESEL"
            >
              <template slot="append-outer">
                <v-btn fab small color="primary">
                  <v-icon  title="Szybkie dodanie pacjenta" @click="quickAddClient"
                           v-if="$can('do','POKO_Klienci_Edycja')">fa-plus</v-icon>
                </v-btn>
                <v-btn fab small color="success" class="ml-2" @click="addToListSelected">
                  <v-icon  title="Dodaj do listy">fa-arrow-down</v-icon>
                </v-btn>
              </template>
              <template v-slot:selection="data">
                <v-container fluid>
                  <v-row no-gutters>
                    <v-col>
                      {{data.item.name + ' '+data.item.surname}}
                    </v-col>
                    <v-col>
                      {{ data.item.description != null ? data.item.description.substr(0,19) : ''}}
                    </v-col>
                    <v-col>
                      {{data.item.pesel}}
                    </v-col>
                    <v-col class="text-right">
                      <v-icon class="mr-2">fa-phone</v-icon>{{data.item.phone}}
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-slot:item="data">
                <v-container fluid>
                  <v-row no-gutters>
                    <v-col>
                      {{data.item.name + ' '+data.item.surname}}
                    </v-col>
                    <v-col>
                      {{ data.item.description != null ? data.item.description.substr(0,19) : ''}}
                    </v-col>
                    <v-col>
                      {{data.item.pesel}}
                    </v-col>
                    <v-col class="text-right">
                      <v-icon class="mr-2">fa-phone</v-icon>{{data.item.phone}}
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="12">
            <v-menu
                v-model="modal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="displayDate"
                    label="Data wygaśnięcia"
                    prepend-icon="fa fa-calendar"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" scrollable @input="closeDatePicker" :min="minimumDate">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Klient
                  </th>
                  <th class="text-left">
                    Akcje
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="item in dodani_klienci"
                    :key="item.id"
                >
                  <td>{{ item.name }}</td>
                  <td><v-icon @click="deleteKlient(item.id)">fa-trash</v-icon></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-dialog v-model="addQuickClientDialog" max-width="500px" v-if="$can('do','POKO_Klienci_Edycja')">
              <v-card>
                <v-toolbar dark class="primary">
                  <v-btn icon @click.native="addQuickClientDialog = false" dark>
                    <v-icon>fa-times</v-icon>
                  </v-btn>
                  <v-toolbar-title>Szybkie dodanie pacjenta</v-toolbar-title>
                </v-toolbar>
                <v-progress-linear :indeterminate="true" v-if="quickClientSaving"></v-progress-linear>
                <v-card-text v-show="!quickClientSaving">
                  <v-form data-vv-scope="quickAddForm" @submit.prevent="saveQuickClient">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field label="Imię*" v-validate="'required'" name="qaddname" id="qaddname"
                                      data-vv-as="Imię"
                                      :error-messages="errors.collect('quickAddForm.qaddname')"
                                      v-model="quickAddPatientData.name"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field label="Nazwisko*" v-validate="'required'" name="qaddsurname"
                                      id="qaddsurname"
                                      :error-messages="errors.collect('quickAddForm.qaddsurname')"
                                      data-vv-as="Nazwisko"
                                      v-model="quickAddPatientData.surname"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field label="Telefon" v-validate="{regex:/^[0-9\+]{8,13}$/}" name="qaddphone"
                                      id="qaddphone"
                                      :error-messages="errors.collect('quickAddForm.qaddphone')"
                                      data-vv-as="Telefon" v-model="quickAddPatientData.phone"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox label="Zgoda na sms" v-model="quickAddPatientData.zgoda_na_sms"></v-checkbox>
                      </v-flex>
                    </v-layout>

                  </v-form>
                </v-card-text>
                <v-card-actions v-show="!quickClientSaving">
                  <v-btn color="success" @click="saveQuickClient">Zapisz</v-btn>
                  <v-btn color="error" @click="addQuickClientDialog=false">Anuluj</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save()" color="success">Zapisz</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close')" color="error">Zamknij</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import swal from "sweetalert";
import {clientService} from "@/services";
import {voucheryService} from "@/services/vouchery.service";
import * as dayjs from "dayjs";

export default {
  name: "VoucherKlientEdycja",
  props: ["voucher"],
  data() {
    return {
      title: 'Edycja vouchera '+this.voucher.nazwa,
      dodani_klienci: [],
      isLoadingClients: false,
      clientKeyword: null,
      wybrany_klient: null,
      clientTimerId: 0,
      clientsList: [],
      loading: false,
      addQuickClientDialog: false,
      quickAddPatientData: {
        name: null,
        surname: null,
        phone: null,
        zgoda_na_sms: false,
        description: null
      },
      quickClientSaving: false,
      modal: false,
      date: new Date(this.voucher.kiedy_wygasa).toISOString().substr(0, 10),
      displayDate: new dayjs(this.voucher.kiedy_wygasa).format('DD-MM-YYYY'),
      minimumDate: new dayjs(this.voucher.kiedy_wygasa).format('YYYY-MM-DD')
    }
  },
  mounted() {
    this.voucher.clients.forEach(elem => {
      this.dodani_klienci.push({
        id: elem.id,
        name: elem.name + ' ' + elem.surname,
      })
    })
  },
  methods: {
    save() {
      if(this.dodani_klienci.length == 0)
      {
        this.showError('Nie wybrano klientów.')
        return
      }
      let klienci = []
      this.dodani_klienci.forEach(elem=> {
        klienci.push(elem.id)
      })
      let data = {
        id: this.voucher.id,
        data_wygasniecia: this.date,
        klienci: klienci
      }
      voucheryService.updateVoucherKlient(data).then(() => {
        this.$emit('close')
      }).catch(()=> {
        this.showError('Bład zapisu edycji vouchera klienta')
      })
    },
    closeDatePicker() {
        this.modal = false
        let dj = dayjs(this.date)
        this.displayDate = dj.format("DD-MM-YYYY")
    },
    quickAddClient() {
      this.quickAddPatientData.name = null;
      this.quickAddPatientData.surname = null;
      this.quickAddPatientData.phone = null;
      this.quickAddPatientData.zgoda_na_sms = false;
      this.addQuickClientDialog = true;
    },
    addToListSelected() {
      if(this.wybrany_klient != null)
      {
        if(this.dodani_klienci.find(x=> x.id == this.wybrany_klient.id) != null)
          return

        this.dodani_klienci.push({
          id: this.wybrany_klient.id,
          name: this.wybrany_klient.name + ' '+this.wybrany_klient.surname,
          initial: false
        })
        this.wybrany_klient = null
      }
    },
    saveQuickClient() {
      this.$validator.validateAll("quickAddForm").then(valid => {
        if (valid) {
          this.quickClientSaving = true;
          clientService
              .create({
                name: this.quickAddPatientData.name,
                surname: this.quickAddPatientData.surname,
                phone: this.quickAddPatientData.phone,
                agreeForHealthServices: true,
                usePhoneForSMS: this.quickAddPatientData.zgoda_na_sms && this.quickAddPatientData.phone && this.quickAddPatientData.phone.length > 0,
                patientConfirmVisitsBySMS: this.quickAddPatientData.zgoda_na_sms && this.quickAddPatientData.phone && this.quickAddPatientData.phone.length > 0,
                patientAgreeToReceiveSMS: this.quickAddPatientData.zgoda_na_sms && this.quickAddPatientData.phone && this.quickAddPatientData.phone.length > 0,
                description: this.quickAddPatientData.description
              })
              .then(resp => {
                this.quickClientSaving = false;
                this.quickAddPatientData.name = null;
                this.quickAddPatientData.surname = null;
                this.quickAddPatientData.phone = null;
                this.quickAddPatientData.zgoda_na_sms = false
                this.addQuickClientDialog = false;
                this.quickAddPatientData.description = null
                if (resp.data != null && resp.data.result != null) {
                  var quickClient = resp.data.result;
                  let newClient = {
                    id: quickClient.id,
                    name: quickClient.name,
                    surname: quickClient.surname,
                    pesel: quickClient.pesel,
                    therapist: quickClient.therapistID,
                    full_text: quickClient.name + ' '+quickClient.surname + (quickClient.pesel != null && quickClient.pesel != '' ? ' '+quickClient.pesel : '') + (quickClient.phone != null && quickClient.phone != '' ? ' '+quickClient.phone : ''),
                    disabled:false,
                    description: quickClient.description,
                    phone: quickClient.phone
                  };
                  this.clientsList.push(newClient);
                  this.wybrany_klient = newClient
                } else {
                  this.showError(false, "Błąd zapisu pacjenta");
                }
              })
              .catch(resp => {
                this.quickClientSaving = false;
                if (
                    resp.response != null &&
                    resp.response.data != null &&
                    resp.response.data.error != null
                ) {
                  this.showError(false, resp.response.data.error.message);
                } else {
                  this.showError(false, "Błąd zapisu pacjenta");
                }
              });
        }
      });
    },
    deleteKlient(id)
    {
      this.dodani_klienci = this.dodani_klienci.filter(e=> e.id !== id)
    },
    fetchClientDebaunce() {
      // cancel pending call
      clearTimeout(this.clientTimerId)
      // delay new call 500ms
      this.clientTimerId = setTimeout(() => {
        this.getClientValues()
      }, 500)
    },
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    getClientValues() {
      this.isLoadingClients = true;
      clientService
          .getAll({query: this.clientKeyword, page: 1, limit: 20, sorting: "surname"})
          .then(data => {
            data.data.result.items.forEach(item => {
              if (!this.clientsList.find(x => x.id === item.id)) {

                this.clientsList.push({
                  id: item.id,
                  name: item.name,
                  surname: item.surname,
                  pesel: item.pesel,
                  therapist: item.therapistID,
                  full_text: item.name + ' '+item.surname + (item.pesel != null && item.pesel != '' ? ' '+item.pesel : '') + (item.phone != null && item.phone != '' ? ' '+item.phone : ''),
                  disabled:false,
                  description: item.description,
                  phone: item.phone
                });
              }
            });
            this.isLoadingClients = false;
          })
          .catch(() => {
            this.isLoadingClients = false;
            this.showError( "Nie można pobrać listy klientów.");
          });
    },
  },
  watch: {
    clientKeyword(val) {
      if (val) {
        this.fetchClientDebaunce();
      }
    },
  }
}
</script>

<style scoped>

</style>